import {
    ProductCustomizableOptionsContainer as SourceProductCustomizableOptionsContainer
} from 'SourceComponent/ProductCustomizableOptions/ProductCustomizableOptions.container';

/** @namespace Elganso/Component/ProductCustomizableOptions/Container */
export class ProductCustomizableOptionsContainer extends SourceProductCustomizableOptionsContainer {
    // containerProps() {
    //     const { options, updateSelectedValues } = this.props;

    //     return {
    //         options,
    //         updateSelectedValues
    //     };
    // }
}

export default ProductCustomizableOptionsContainer;
